// extracted by css-extract-rspack-plugin
export default {"treeContainer":"dEAgi"};